import { GrassList } from "../GrassList";
import "./EventCard.css";

const EventCard = ({ event }) => {
	Date.prototype.toShortFormat = function () {
		const monthNames = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];

		const day = this.getDate();

		const monthIndex = this.getMonth();
		const monthName = monthNames[monthIndex];

		const year = this.getFullYear();

		return `${monthName} ${day}`;
	};

	let thisDate = event.date.toShortFormat();

	return (
		<div className="eventCard">
			<div className="eventDetails">
				<div className="eventCal">
					<div className="eventCalMonth">
						<div>{thisDate.split(" ")[0]}</div>
					</div>
					<div className="eventCalDay">
						<div>{thisDate.split(" ")[1]}</div>
					</div>
				</div>
				<div>
					<div className="eventTitle">{event.title}</div>
					<div className="eventLocation">{event.where}</div>
				</div>
			</div>
			<div className="eventInfo">
				<div>
					{event.resultsurl ? (
						<>
							<a
								href={event.resultsurl}
								target="_blank"
								rel="noopener noreferrer"
							>
								View Results
							</a>
							<br />
						</>
					) : null}
					{event.past != true && event.registerurl ? (
						<>
							<a href={event.registerurl} target="_blank" rel="noreferrer">
								Register Here
							</a>
							<br />
						</>
					) : null}
					{event.teams}
					<br />
					{event.group}
					<br />
				</div>
			</div>
		</div>
	);
};

export default EventCard;
